import React from "react"
import { IconButton, Tooltip, useTheme } from "@mui/material"
import { SxProps } from "@mui/system"

interface TooltipButtonProps {
  title: string
  onClick: () => void
  icon: React.ReactNode
  sx?: SxProps
}

export const TooltipButton: React.FC<TooltipButtonProps> = ({ title, onClick, icon, sx }) => {
  const theme = useTheme()

  return (
    <Tooltip
      title={title}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: theme.palette.primary.contrastText,
            color: theme.palette.primary.main,
            fontSize: "11px",
            fontWeight: "normal",
            lineHeight: "23px",
            boxShadow: "0px 3px 6px #00000029",
            borderRadius: "8px",
            py: 0
          }
        },
        arrow: {
          sx: {
            color: theme.palette.primary.contrastText
          }
        }
      }}
    >
      <IconButton
        sx={{
          color: theme.palette.primary.contrastText,
          "&:hover": {
            backgroundColor: (theme.palette.primary as any)[400]
          },
          ...sx
        }}
        onClick={onClick}
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
}
